

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.Mogjxl3p.js","_app/immutable/chunks/stores.9-uguZOe.js","_app/immutable/chunks/client.o7eAp_P-.js"];
export const stylesheets = [];
export const fonts = [];
